import 'suggestions-jquery';
import {
  initFullnameSuggestions
} from './src/dadata.name';
import {
  initMailSuggestions
} from './src/dadata.mail';
import './src/dadata.address';
import './src/utils';
import LazyLoad from 'vanilla-lazyload';
import './src/cleave';
import {
  Sidebar
} from './src/sidebar';
import './src/catalog-menu';
import {
  search
} from './src/search';
import {
  Accordeon
} from './src/accordeon';
import {
  Dialog
} from './src/dialog';
import './src/notice';
import {
  showCookie
} from './src/cookie';
import {
  showUpdateModal
} from './src/dialog.update';

export const dialog = new Dialog();
export const mobileMenu = new Sidebar('#menu', {
  toggler: '.action__link--menu'
});

export const lazy = new LazyLoad({
  elements_selector: '.lazyload'
});

document.body.classList.add('page-loaded');
initFullnameSuggestions('.suggest-fullname');
initMailSuggestions('.suggest-email');
search.init();


new Accordeon('.footer-menu');
showCookie();
showUpdateModal();
